import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil, startWith, tap, switchMap, filter, map } from 'rxjs/operators';
import { Subject, merge } from 'rxjs';
import { AuthenticationService, LanguagesService, DropdownsService } from 'app/services';
import { AttachmentsService } from 'app/services/attachments.service';
import { OwnersService } from 'app/services/owners.service';
import { CommercialPropertiesService } from 'app/services/commercial-properties.service';
import { pickBy, isEmpty, toUpper, map as mapLodash, orderBy, groupBy, union, uniq } from 'lodash';
import { GetImageSrcPipe } from 'app/pipes/get-image-src.pipe';
import { fuseAnimations } from '@fuse/animations';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { AccountsService } from 'app/services/accounts.service';
import { SortPropertyDataPipe } from 'app/pipes/sort-property-data.pipe';
import { CrmMenuService } from 'app/services/crm-menu.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UntypedFormGroup } from '@angular/forms';
import { BookingsCreateModalComponent } from 'app/main/holiday-rentals/bookings/bookings-create-modal/bookings-create-modal.component';
import { MatDialog } from '@angular/material/dialog';
import {
  MatCalendar,
  MatCalendarCellCssClasses,
} from '@angular/material/datepicker';
import { CompaniesService } from 'app/services/companies.service';
@Component({
  selector: 'commercials-overview',
  templateUrl: './commercials-overview.component.html',
  styleUrls: ['./commercials-overview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [GetImageSrcPipe, SortPropertyDataPipe]
})
export class CommercialsOverviewComponent implements OnInit {

  @Input() propertyId: string;

  property: any;
  imageData: any;
  _id: any;
  currentLang: any;
  private _unsubscribeAll: Subject<any>;
  currentAgency: any;
  currentUser: any;
  ownerData: any;
  basketData: any;
  otherProperties: any = [];
  languages: [];
  DescriptionTitle = null;
  Description = null;
  SaleRentCheck = 0; // 0=sale  1=rent
  selectedDescLang: any;
  imageObject: Array<object> = [];
  mediaType: string;
  loadingImages = false;
  reloadImages: EventEmitter<any>;
  document_key = 'false';
  imageSize = {
    width: 500,
    height: 500,
    space: 4
  } as any;
  slide = 0;
  @ViewChild('ImageContainer', { static: false }) ImageContainer: ElementRef;
  calendarReload: EventEmitter<any>;
  bookings = [];
  searchDialogRef: any;
  stRental = false;
  loadingBookings = false;
  @ViewChild(MatCalendar, { static: false }) calendar: MatCalendar<Date>;
  tabs: any;
  accounts: any;
  loadingAccounts = true;
  pId: any;
  model: string;
  company: string;
  additional_info = false;
  has_private_info = false;
  private_info_data: any;
  isCommHolidayRentalModule: any;
  isLongTermRentalModule: any;
  constructor(
    private _commercialService: CommercialPropertiesService,
    private _translateService: TranslateService,
    private _authenticationService: AuthenticationService,
    private _getImageSrcPipe: GetImageSrcPipe,
    private router: Router,
    private _ownersService: OwnersService,
    private _languagesService: LanguagesService,
    private _attachmentsService: AttachmentsService,
    private _dropDownService: DropdownsService,
    private mediaObserver: MediaObserver,
    private _accountService: AccountsService,
    private _crmMenuService: CrmMenuService,
    private sanitizer: DomSanitizer,
    private _matDialog: MatDialog,
    private _companiesService: CompaniesService
  ) {
    this._unsubscribeAll = new Subject();
    this.currentLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
    this.selectedDescLang = this._translateService.currentLang === 'es' ? 'ES' : toUpper(this._translateService.currentLang);
    this.currentAgency = this._authenticationService.currentAgencyValue;
    this.currentUser = this._authenticationService.currentUserValue;
    this.isCommHolidayRentalModule = this._crmMenuService.isCommHolidayRentalModule;
    this.isLongTermRentalModule = this._crmMenuService.isLongTermRentalModule;
    this.reloadImages = new EventEmitter();
    this.calendarReload = new EventEmitter();
  }

  ngOnInit(): void {
    this._translateService.onLangChange
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this.currentLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
      });


    if (this.propertyId) {
      this._id = this.propertyId;
    } else {
      this._id = this.router.url.split('/')[3];
    }
    this._commercialService.getPropertyData(this._id)
      .subscribe((data: any) => {
        this.property = data;
        this._id = this.property._id;
        this.pId = this.property._id;
        this.model = 'commercial_images';
        if(this.property.from_residential){
          this.pId = this.property.res_id;
          this.model = 'properties_images';
        }
        if (this.property?.st_rental) {
          this.stRental = true;
          this.calendarReload.next(true);
        } 
        if (
          this.property?.private_info_object &&
          this.property?.private_info_object[this.currentAgency._id]
        ) {
          this.has_private_info = true;
          this.private_info_data = this.property.private_info_object[this.currentAgency._id];
          if (
            this.private_info_data?.keyholder_phone || this.private_info_data?.key_reference ||
            this.private_info_data?.mortgage_value || this.private_info_data?.private_info ||
            (this.private_info_data?.share_owners?.length > 0 && this.private_info_data?.share_owners[0]?.private_info)
          ) {
            this.additional_info = true;
          }
        }
        this.getPropertyImages(this.pId, this.model).then(); 
        this._accountService.getTodayLeads(this.property.reference, 'commercial').subscribe((response: any) => {
          this.accounts = response;
          this.loadingAccounts = false;
        });
        this.checkCommissionsTab(this.property);
        if (!isEmpty(this.property) && !isEmpty(this.property.longitude)) {
          this.property.longitude = parseFloat(this.property.longitude);
          this.property.latitude = parseFloat(this.property.latitude);
        }
        this._languagesService.getLanguagesForSystem().pipe(takeUntil(this._unsubscribeAll)).subscribe((langs: any) => {
          this.languages = langs;
          this.SaleRentToggle(0);
        });

        let owner: string = '';
        const privateInfoObj = this.property.private_info_object as UntypedFormGroup;
        pickBy(privateInfoObj, (value, key) => {
          if (key === this.currentAgency._id) {
            if (value.hasOwnProperty('keyholder_company'))
              this.company = value.keyholder_company;
            if (value.hasOwnProperty('share_owners') && value.share_owners.length > 0)
              owner =  value.share_owners[0]?.owner;
          }
        });

        if (this.company) {
          this._companiesService
            .getById(this.company)
            .pipe(
              takeUntil(this._unsubscribeAll)
            )
            .subscribe((companyData: any) => {
              this.company = companyData.commercial_name;
            });
        }

        if (owner && owner !== '') {
          try {
            this._ownersService.getById(owner).subscribe((ownerdata: any) => {
              if (ownerdata) {
                this.ownerData = ownerdata;
                try {
                  if (this.ownerData?.properties?.length > 0 || this.ownerData?.commercial_properties?.length > 0) {
                    let ownerProperties = this.ownerData.properties.filter(prop => prop !== this.property?.reference)
                    let ownerCommercialProperties = this.ownerData.commercial_properties.filter(prop => prop !== this.property?.reference)
                    this.otherProperties = uniq(union(ownerCommercialProperties, ownerProperties));
                  }
                } catch (e) {}
              }
            });
          } catch (e) {}
        }

        this.mediaObserver.asObservable()
          .pipe(
            tap(() => this.loadingImages = true),
            takeUntil(this._unsubscribeAll),
            filter((changes: MediaChange[]) => changes.length > 0),
            map((changes: MediaChange[]) => changes[0])
          )
          .subscribe((change: MediaChange) => {
            this.imageSize = {
              width: 500,
              height: 500,
              space: 4
            };

            setTimeout(() => {
              if (this.ImageContainer) {
                const size = (this.ImageContainer.nativeElement as HTMLElement).offsetWidth;
                this.imageSize = {
                  width: size - 32,
                  height: size - 32,
                  space: 4
                };
              }
              this.loadingImages = false;
            }, 1000);
          });

        this.getTabs(this.property.type_one).then();
        this.loadFeatures(this.property.type_one).then();
      });
    // this._attachmentsService.getModelAttachments(this._id, 'commercial_images').pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe((data: any) => {
    //     // this.imageData = data; 
    //     this.imageObject = [];
    //     this.mediaType = 'picture';
    //     this.loadingImages = false;
    //     if (data.length > 0) {
    //       data.forEach(element => {
    //         const src = this._getImageSrcPipe.transform(element);
    //         const img = {
    //           image: src,
    //           thumbImage: src,
    //           alt: 'property image'
    //         };
    //         this.imageObject.push(img);
    //       });
    //     }
    //   });
    merge(this.reloadImages)
      .pipe(
        startWith(''),
        tap(() => this.loadingImages = true),
        takeUntil(this._unsubscribeAll),
        switchMap(() => {
          return this._attachmentsService.getModelAttachments(this.pId, this.model,this.document_key);
        })
      )
      .subscribe((data: any) => {
        this.imageObject = [];
        this.mediaType = 'picture';
        this.loadingImages = false;
        if (data.length > 0) {
          data.forEach(element => {
            const src = this._getImageSrcPipe.transform(element);
            setTimeout(() => {
              if (src) {
                const img = {
                  image: src,
                  thumbImage: src,
                  alt: 'property image'
                };
                this.imageObject.push(img);
              }

            }, 1000);
          });
        }
      });
    this._commercialService.getBaskets(this._id)
      .subscribe((data: any) => {
        this.basketData = data.body;
      });
    
    this.calendarReload
      .pipe(
          takeUntil(this._unsubscribeAll),
          tap(() => (this.loadingBookings = true)),
          switchMap(() => {
            return this._commercialService.getPropertyBookings(
              this.property.from_residential ? this.pId : this._id
            );
          })
      )
      .subscribe((data: any) => {
          if (data) {
            this.bookings = data;
          }
          setTimeout(() => {
            this.calendar.updateTodaysDate();
          }, 1000);
          this.loadingBookings = false;
      });
  }

  sanitizeHTML(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  SaleRentToggle(value): void {
    this.SaleRentCheck = value;
    if (value === 0) {
      this.DescriptionTitle = '';
      if (!isEmpty(this.property) && !isEmpty(this.property.title) && !isEmpty(this.property.title[this.selectedDescLang])) {
        this.DescriptionTitle = this.property.title[this.selectedDescLang];
      }
      if (!isEmpty(this.property) && !isEmpty(this.property.description) && !isEmpty(this.property.description[this.selectedDescLang])) {
        this.Description = this.property.description[this.selectedDescLang];
      }

    } else {
      if (!isEmpty(this.property) && !isEmpty(this.property.rental_title) && !isEmpty(this.property.rental_title[this.selectedDescLang])) {
        this.DescriptionTitle = this.property.rental_title[this.selectedDescLang];
      }
      if (!isEmpty(this.property) && !isEmpty(this.property.rental_description) && !isEmpty(this.property.rental_description[this.selectedDescLang])) {
        this.Description = this.property.rental_description[this.selectedDescLang];
      }

    }
  }
  selectDescLang(lang, check): void {
    this.selectedDescLang = lang;
    this.DescriptionTitle = '';
    if (check === 0) {
      if (!isEmpty(this.property) && !isEmpty(this.property.title) && !isEmpty(this.property.title[lang])) {
        this.DescriptionTitle = this.property.title[lang];
      }
      if (!isEmpty(this.property) && !isEmpty(this.property.description) && !isEmpty(this.property.description[lang])) {
        this.Description = this.property.description[lang];
      }
    } else {
      if (!isEmpty(this.property) && !isEmpty(this.property.rental_title) && !isEmpty(this.property.rental_title[lang])) {
        this.DescriptionTitle = this.property.rental_title[lang];
      }
      if (!isEmpty(this.property) && !isEmpty(this.property.rental_description) && !isEmpty(this.property.rental_description[lang])) {
        this.Description = this.property.rental_description[lang];
      }

    }
  }
  slideShow(): void {
    this.reloadImages.next(true);
  }

  async getTabs(typeOne): Promise<void> {
    const filterTabs = {
      show_in_type_one: { $in: [typeOne] }
    };
    this._commercialService.getAllFeatureTabs(filterTabs)
      .subscribe((data: any) => {
        const keysData = mapLodash(data, 'key');
        this.tabs = keysData;
      });
    return this.tabs;
  }
  async loadFeatures(typeOne): Promise<void> {
    const filterFeatures = { show_in_type_one: { $in: [typeOne] } };
    this._commercialService.getFeaturesAll(filterFeatures)
      .subscribe((data: any) => {

        data = orderBy(data, ['tab_in_crm'], ['asc']);
        data = orderBy(data, ['value'], ['asc']);
        const tabsData: any = groupBy(data, 'tab_in_crm');
      });
  }
  // here p is property
  checkCommissionsTab(p): boolean {
    let status = false;
    let pio = this.has_private_info ? this.private_info_data : '';
      if (
          (pio && (pio.commission_unit || pio.commission || pio.commission_unit_owner || pio.commission_owner)) ||
          (p.commission_unit_split || p.commission_split)
      ) {
          status = true;
      }
    return status;
  }

  // getAllImages
  async getPropertyImages(pId, model): Promise<void> {
    this._attachmentsService.getModelAttachments(pId, model,this.document_key).pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data: any) => {
        // this.imageData = data; 
        this.imageObject = [];
        this.mediaType = 'picture';
        this.loadingImages = false;
        if (data.length > 0) {
          data.forEach(element => {
            const src = this._getImageSrcPipe.transform(element);
            const img = {
              image: src,
              thumbImage: src,
              alt: 'property image'
            };
            this.imageObject.push(img);
          });
        }
      });
  }

  dateChanged(date): void {
    this.searchDialogRef = this._matDialog.open(
        BookingsCreateModalComponent,
        {
          panelClass: 'booking-form-dialog',
          data: {
            date: date,
            propertyId: this.property.from_residential ? this.pId : this._id,
          },
        }
    );
    this.searchDialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          this.calendarReload.next(true);
        }
      });
  }

  CalendarFilter = (date: any): boolean => {
    const calendarDate = new Date(date._d).getTime();
    for (const booking of this.bookings) {
      if (booking.status === 'blocked') {
        for (const element of booking.booked_dates) {
          const bookingDate = element.split('-');
          if (
            new Date(
              parseInt(bookingDate[2], 10),
              parseInt(bookingDate[1], 10) - 1,
              parseInt(bookingDate[0], 10)
            ).getTime() === calendarDate
          ) {
              return false;
          }
        }
      }
    }
    return true;
  };

  dateClass(): any {
    return (date: any): MatCalendarCellCssClasses => {
      const calendarDate = new Date(date._d).getTime();
      for (const booking of this.bookings) {
        for (let i = 0; i < booking.booked_dates.length; i++) {
          const bookingDate = booking.booked_dates[i].split('-');
          if (
            new Date(
              parseInt(bookingDate[2], 10),
              parseInt(bookingDate[1], 10) - 1,
              parseInt(bookingDate[0], 10)
            ).getTime() === calendarDate
          ) {
            if (
              booking.status === 'active' && i === 0
            ) {
              return 'lower-diagonal-active';
            } else if (
              booking.status === 'active' &&
              i === booking.booked_dates.length - 1
            ) {
              return 'upper-diagonal-active';
            } else if (booking.status === 'active') {
              return 'active';
            } else if (booking.status === 'blocked') {
              return 'blocked';
            } else if (
              (booking.status === 'deposit received' || booking.status === 'security deposit') &&
              i === 0
            ) {
              return 'lower-diagonal-green';
            } else if (
              (booking.status === 'deposit received' || booking.status === 'security deposit') &&
              i === booking.booked_dates.length - 1
            ) {
              return 'upper-diagonal-green';
            } else if (
              booking.status === 'deposit received' ||
              booking.status === 'security deposit'
            ) {
              return 'greenColor';
            } else if (
              booking.status === 'fully paid' && i === 0
            ) {
              return 'lower-diagonal-fully-paid';
            } else if (
              booking.status === 'fully paid' &&
              i === booking.booked_dates.length - 1
            ) {
              return 'upper-diagonal-fully-paid';
            } else if (
              booking.status === 'fully paid'
            ) {
              return 'fully-paid';
            } else if (
              booking.status === 'on hold' && i === 0
            ) {
              return 'lower-diagonal-on-hold';
            } else if (
              booking.status === 'on hold' &&
              i === booking.booked_dates.length - 1
            ) {
              return 'upper-diagonal-on-hold';
            } else if (booking.status === 'on hold') {
              return 'on-hold';
            }
          }
        }
      }
      return;
    };
  }

}
